import React from 'react'

import HoverableArrowLink from '@components/common/HoverableArrowLink'

import { TimedSectionLink } from '@src/types/navigation'

import NavTooltip from '../NavTooltip'

type Props = {
  section: TimedSectionLink
}

export default function TimedSection({ section }: Props) {
  return (
    <section className='flex flex-col items-start'>
      <NavTooltip>{section.durationText}</NavTooltip>
      <HoverableArrowLink
        className='leading-mid font-bold mt-1 mb-2'
        href={section.link}
        text={section.title}
      >
        <p>{section.description}</p>
      </HoverableArrowLink>
    </section>
  )
}
